import gql from 'graphql-tag';
import { mutation } from 'services/graphql';

export const createSurfaceNodeFileUploadUrlMutation = gql`
  mutation createSurfaceNodeFileUploadUrl(
    $input: CreateSurfaceNodeFileUploadUrlInput!
  ) {
    createSurfaceNodeFileUploadUrl(input: $input) {
      data {
        url
        bucketName
        region
      }
      error
    }
  }
`;

export default mutation(createSurfaceNodeFileUploadUrlMutation);
